// extracted by mini-css-extract-plugin
export default {"container":"Poll_container__njim4","questions":"Poll_questions__nvzNc","left":"Poll_left__KjDHo","right":"Poll_right__a5aqJ"};